import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  AssistanceSectionNew,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/ecommerceServiceData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";
import Services_we_offer from "../../component/Services_Component/Services_we_offer";

const EcommerceService = () => {
  useMetaTags({
    title:
      "How Our eCommerce Development Services Build Scalable Web Stores",
    description:
      "Explore how our eCommerce development services help businesses launch fast, secure, and user-friendly online stores that drive sales, improve UX, and grow revenue.",
    keywords:
      "ecommerce website development Services, ecommerce website developer, ecommerce development company, e commerce development, ecommerce development agency, ecommerce website development agency, ecommerce website design companies, e commerce app development, ecommerce web development, ecommerce mobile app development, ecommerce web design company, ecom website development, custom ecommerce development, e commerce development services", });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                eCommerce Website Development services  Company
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/e-commerce.avif"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  If you want to expand your online venture, it is very much crucial to become affiliated with a professional <b>e-Commerce website development company</b>. A professionally built eCommerce website not only provides improved user experience but also boosts sales and establishes brand trust.Choose a company that provides tailored ecommerce solutions like website development, cart integration, secure payment gateways, and mobile responsiveness. The proper development team will analyze your business requirements and develop a scalable online store based on your objectives. Whether you are introducing a new product or redesigning an old site, the professional <b>e-Commerce website development</b> will keep you ahead of the competition and build an ease-in-use online shopping experience for the clients.
                </p>
              </div>
            </div>

            <Benefits_section data={BenefitSection} />

            <Handle_Largedata_section LargeData={LargeData} />

            <Assistance_section data={AssistanceSectionNew} />

            <Custom_section data={CustomSection} />

            <Role_writing data={roleWriting} />

            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default EcommerceService;
